module.exports = __webpack_public_path__ + "iPhone_X_icon.svg?59b5889b91a76e24e3434297f50be30c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/devices/iPhone_X_icon.svg
// module id = 232
// module chunks = 0